import { createSelector } from 'reselect';

const stateSelector = (state: any) => state.requests;

export const getAllRequestsSelector = createSelector(
  stateSelector,
  requests => requests,
);
